import React, { useState } from "react";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import Button from "../common/Button/Button";
import "./Header.css";
import HeroNavLink from "../Hero/HeroNavLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { getCurrentLang, switchLanguage } from "../../store/aboutStore";
const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [currentLang, setCurrentLang] = useState(getCurrentLang());
  const isRTL = currentLang === "ar";
  const location = useLocation();


const matchWithEntreprise = useMatch("/inscription/:code/:entrepriseId");
const matchWithoutEntreprise = useMatch("/inscription/:code");
const isInscriptionPage = Boolean(matchWithEntreprise || matchWithoutEntreprise);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleLanguage = () => {
    const newLang = currentLang === "fr" ? "ar" : "fr";
    setCurrentLang(newLang);
    switchLanguage(newLang);
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          <img src="/images/logo.png" alt="Logo" />
        </Link>

        {isInscriptionPage ? (
          // If on /inscription page, only show language switcher
          <div
            className="language-toggle"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              // marginRight: isRTL ? "auto" : "0",
              // marginLeft: isRTL ? "0" : "auto",
            }}
          >
            {isRTL && <FontAwesomeIcon icon={faGlobe} className="globe-icon" />}
            <button
              onClick={toggleLanguage}
              className="language-button gr-title-2"
              aria-label="Toggle language"
            >
              {currentLang === "fr" ? "العربية" : "Français"}
            </button>
            {!isRTL && (
              <FontAwesomeIcon icon={faGlobe} className="globe-icon" />
            )}
          </div>
        ) : (
          <>
            <button
              className={`mobile-menu-btn ${isMenuOpen ? "active" : ""}`}
              onClick={toggleMenu}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>

            <nav className={`nav ${isMenuOpen ? "active" : ""}`}>
              <div className="nav-left">
                {/* Add any left side links here if needed */}
              </div>
              <div className="nav-right">
                <HeroNavLink />
                <div className={`language-toggle ${isRTL ? "rtl" : "ltr"}`}>
                  {!isRTL && (
                    <FontAwesomeIcon icon={faGlobe} className="globe-icon" />
                  )}
                  <button
                    onClick={toggleLanguage}
                    className="language-button gr-title-2"
                    aria-label="Toggle language"
                    dir={isRTL ? "rtl" : "ltr"}
                  >
                    {currentLang === "fr" ? "Français" : "العربية"}
                  </button>
                  {isRTL && (
                    <FontAwesomeIcon
                      icon={faGlobe}
                      className="globe-icon gr-title-2"
                    />
                  )}
                </div>
                {/* <Button variant="connexion" onClick={() => navigate('https://yatamedical.com/auth/login')}>
                Se connecter
              </Button> */}
              </div>
            </nav>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
